import React, { useState } from 'react';
import { Row, Col, Button, Radio, Tag, Input, notification, Table, Tabs, Skeleton, DatePicker } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { UserOutlined, BankOutlined, MailOutlined, ShoppingCartOutlined, TagsOutlined, PhoneOutlined } from "@ant-design/icons";
import moment from 'moment';
import LayoutDetail from '../Layout/';
import useWindowDimensions from '../../hooks/windowDimensionsHook';
import { useLocation } from "react-router-dom";
import apick from '../../api/apicheckout';
import { connect } from 'react-redux'

const { TextArea } = Input;
const { Search } = Input;
const { TabPane } = Tabs;
const columns = [

    {
        title: 'Cliente',
        dataIndex: 'Cliente',
        width: 150,
    },
    {
        title: 'CPF',
        dataIndex: 'cpf',
        width: 150,
    },
    {
        title: 'Filial',
        dataIndex: 'Filial',
        width: 150,
    },
    {
        title: 'CF',
        dataIndex: 'CF',
        width: 150,
    },
    {
        title: 'Requisição',
        dataIndex: 'requisicao',
        width: 150,
    },
    {
        title: 'Valor',
        dataIndex: 'Valor',
        width: 150,
    }
];
const columnsProduto = [

    {
        title: 'Produto',
        dataIndex: 'Descricao',
        width: 150,
    },
    {
        title: 'Quantidade',
        dataIndex: 'Quantidade',
        width: 150,
    },
    {
        title: 'Valor Unitário',
        dataIndex: 'Valor',
        width: 150,
    },
    {
        title: 'Valor Total',
        dataIndex: 'Valor',
        width: 150,
        render: text =>
            <Tag>{text}</Tag>
    }
];
const gerarLinkSucesso = link => {
    notification['success']({
        message: 'Link Gerado',
        description:
            'O link froi criado em:' + link,
    });
};
function Cadastrar({ localizado, link, asyncGerarLink, produto, asyncBuscarProduto }) {
    const { height, width } = useWindowDimensions();
    const location = useLocation();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [codigoProduto, setCodigoProduto] = useState(0);
    const [total, setValorTotal] = useState(0);
    const [quantidade, setQuantidade] = useState(1);
    const [token] = useState(location.state.detail.token);

    //Formulario:
    const [telefoneCliente, setTelefoneCliente] = useState('')
    const [nomeCliente, setNomeCliente] = useState('')
    const [emailCliente, setEmailCliente] = useState(0)
    const [filial, setFilial] = useState(0)
    const [tipoFrete, setTipoFrete] = useState(0)
    const [valorFrete, setValorFrete] = useState(0)
    const [tipoParcelamento, setTipoParcelamento] = useState(0)
    const [requisicoes, setRequisicoes] = useState([])
    const [produtos, setProdutos] = useState([])

    function adicionarProdutos(prod) {
        console.log('adicoinar Produtos', prod)
        setProdutos(produtos => [...produtos, { Codigo: prod.Codigo, Valor: prod.PrecoSugerido, Quantidade: quantidade, Descricao: prod.Descricao }])
    }

    async function buscarProduto() {
        console.log('Buscando pelo codigo com token:', token)

        console.log('Buscando pelo codigo:', codigoProduto)
        await asyncBuscarProduto({ codigo: codigoProduto, token: token })
    }
    function calcularQuantidade(value) {
        var qtdTotalValor = produto.PrecoSugerido * value;
        setValorTotal(qtdTotalValor);
        setQuantidade(value);
    }
    async function gerarLink() {

        const documents = {
            nomeCliente,
            filial,
            telefoneCliente,
            emailCliente,
            tipoFrete,
            valorFrete,
            tipoParcelamento,
            requisicoes,
            produtos
        };

        await asyncGerarLink({ documents: documents, token: token })
        console.log('Enviando documentos:', documents);

        LinkSucesso();
    }
    function LinkSucesso() {
        console.log('Link gerado foi:', link)
        gerarLinkSucesso(link)
    }
    return (
        <>
           
            <Row>
                <Col span={6} style={{ paddingRight: 4, marginTop: 10 }}><Input size="large" placeholder="Código Cliente" prefix={<UserOutlined />} /></Col>
                <Col span={12} style={{ marginTop: 10 }}><Input onChange={(e) => setNomeCliente(e.target.value)} size="large" placeholder="Nome Cliente" prefix={<UserOutlined />} /></Col>
            </Row>
            <Row>
                <h3>Informações de contato</h3>
            </Row>
            <Row>
                <Col span={8} style={{ paddingRight: 4, marginTop: 10 }}>
                    <Input onChange={(e) => setFilial(e.target.value)} size="large" placeholder="Filial" prefix={<BankOutlined />} /></Col>
                <Col span={8} style={{ marginTop: 10 }}>
                    <Input onChange={(e) => setTelefoneCliente(e.target.value)} size="large" placeholder="Telefone" prefix={<PhoneOutlined />} /></Col>
                <Col span={8} style={{ marginTop: 10 }}>
                    <Input onChange={(e) => setEmailCliente(e.target.value)} size="large" placeholder="Email" prefix={<MailOutlined />} /></Col>
            </Row>
            <Row>
                <h3>Parcelas</h3>
            </Row>
            <Row>
                <Col span={16} style={{ paddingRight: 4, marginTop: 10 }}>
                    <Radio.Group onChange={(e) => setTipoParcelamento(e.target.value)} size="large" defaultValue="a">
                        <Radio.Button value="1">Á vista</Radio.Button>
                        <Radio.Button value="2">2x</Radio.Button>
                        <Radio.Button value="3">3x</Radio.Button>
                        <Radio.Button value="5">5x</Radio.Button>
                        <Radio.Button value="6">6x</Radio.Button>
                        <Radio.Button value="7">7x</Radio.Button>
                        <Radio.Button value="8">8x</Radio.Button>
                        <Radio.Button value="9">9x</Radio.Button>
                        <Radio.Button value="10">10x</Radio.Button>
                    </Radio.Group>
                </Col>
                <Col span={6} style={{ paddingRight: 4, marginTop: 10 }}>
                    <Input onChange={(e) => setValorFrete(e.target.value)} size="large" placeholder="Valor Frete" prefix={<ShoppingCartOutlined />} />

                </Col>
            </Row>
            <Row>
                <h3>Frete</h3>
            </Row>
            <Row>
                <Radio.Group onChange={(e) => setTipoFrete(e.target.value)} name="radiogroup" defaultValue={1}>
                    <Radio value={1}>SEDEX</Radio>
                    <Radio value={2}>FORTAEZA (Local)</Radio>
                    <Radio value={3}>SP (Local)</Radio>
                    <Radio value={4}>EXTRA</Radio>
                </Radio.Group>
            </Row>
            <Row>
                <Tabs defaultActiveKey="1">
                    <TabPane tab="Requisição" key="1">
                        <Row>
                            <Col style={{ paddingRight: 4, marginTop: 10 }}>
                                <Input size="large" placeholder="Filial" prefix={<UserOutlined />} />
                            </Col>
                            <Col style={{ paddingRight: 4, marginTop: 10 }}>
                                <Input size="large" placeholder="Requisição" prefix={<UserOutlined />} />
                            </Col>
                            <Col style={{ paddingRight: 4, marginTop: 10 }}>
                                <Button block shape="round" style={{ width: 200, backgroundColor: '#114873', borderColor: '#114873' }} type="primary" htmlType="submit">
                                    Buscar
                                </Button>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                {
                                    loading == false ? (
                                        <Table columns={columns} dataSource={data} scroll={{ x: 1100 }} pagination={{ pageSize: 10 }} />
                                    ) : (
                                            <Skeleton loading />
                                        )
                                }
                            </Col>
                        </Row>
                    </TabPane>
                    <TabPane tab="Produto" key="2">
                        <Row>
                            <Col style={{ paddingRight: 4, marginTop: 10 }}>
                                <Input size="large" onChange={(e) => setCodigoProduto(e.target.value)} placeholder="Produto" prefix={<TagsOutlined />} />
                            </Col>

                            <Col style={{ paddingRight: 4, marginTop: 10 }}>
                                <Button onClick={buscarProduto} block style={{ backgroundColor: '#114873', borderColor: '#114873' }} type="primary" htmlType="submit">
                                    Buscar
                                </Button>
                            </Col>
                        </Row>
                        <Row>
                            <h3>Descrição:</h3>
                        </Row>

                        {

                            produto != undefined ? (
                                <>
                                    <Row>
                                        <TextArea defaultValue={produto.Descricao}>
                                        </TextArea>
                                    </Row>
                                    <Row>
                                        <h3>Outras definições</h3>
                                    </Row>
                                    <Row>
                                        <Col style={{ paddingRight: 4, marginTop: 10 }}>
                                            <Input size="large" onChange={(e) => calcularQuantidade(e.target.value)} placeholder="Quantidade" prefix={<UserOutlined />} />
                                        </Col>
                                        <Col style={{ paddingRight: 4, marginTop: 10 }}>
                                            <Input size="large" value={produto != undefined ? (produto.PrecoSugerido) : ''} placeholder="Valor" prefix={<UserOutlined />} />
                                        </Col>
                                        <Col style={{ paddingRight: 4, marginTop: 10 }}>
                                            <Input size="large" value={total} placeholder="Valor Total" prefix={<UserOutlined />} />
                                        </Col>
                                        <Col style={{ paddingRight: 4, marginTop: 10 }}>
                                            <Button block onClick={() => adicionarProdutos(produto)} style={{ backgroundColor: '#114873', borderColor: '#114873' }} type="primary" htmlType="submit">
                                                Adicionar
                                </Button>
                                        </Col>
                                    </Row>
                                    <Row>
                                        {
                                            loading == false ? (
                                                <Table columns={columnsProduto} dataSource={produtos} scroll={{ x: 1100 }} pagination={{ pageSize: 10 }} />
                                            ) : (
                                                    <Skeleton loading />
                                                )
                                        }
                                    </Row>
                                </>
                            ) : null
                        }
                    </TabPane>
                </Tabs>

            </Row>
            <Row>
                <Button block style={{ backgroundColor: '#114873', borderColor: '#114873' }} type="primary" onClick={gerarLink}>
                    Gerar Link
            </Button>
            </Row>
        </>
    );
}

const mapState = (state) => ({
    produto: state.checkout.produto,
    requisicao: state.checkout.requisicao,
    localizado: state.checkout.localizado,
    link: state.checkout.link
})
const mapDispatch = (dispatch) => ({
    asyncBuscarProduto: payload => dispatch.checkout.asyncBuscarProduto(payload),
    asyncBuscarRequisicao: payload => dispatch.checkout.asyncBuscarRequisicao(payload),
    asyncGerarLink: payload => dispatch.checkout.asyncGerarLink(payload),
})

export default connect(mapState, mapDispatch)(Cadastrar)